



























import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import ClaimManagement from "@/components/shipments/ClaimManagement.vue";

@Component({})
export default class BreadCrumbNew extends Vue {
  @Prop({}) navigationKey;
  @Prop({}) mbeTracking;
  @Prop({}) postfix?: string;

  async navigateRoute(item) {
    if (item.disabled) return;
    if ((window as any).dataLayer) {
      const layerData = {
        event: "click_header_menu_level2",
        event_data: {
          click_text: this.$i18n.t(item.key, { lng: "en" })
        }
      };
      (window as any).dataLayer.push(layerData);
    }
    await this.$router.push({
      name: item.route,
      params: item.params || {},
      query: item.query || {}
    });
  }

  get isInboundShipmentEnabled() {
    return (
      this.$store.getters["customer/config"].canSelectSShipmentType &&
      this.$store.getters.features.inbound
    );
  }

  get navigation() {
    const shipmentsRoutes: any = [
      { key: "new_shipment", route: "ShipmentsManagement", index: "1" },
      { key: "mbe_centre_pickups", route: "PickupsList", index: "2" },
      { key: "historic_closures", route: "ClosuresList", index: "3" },
      { key: "new_shipment_button", route: "NewShipment", index: "4" }
    ];

    if (this.isInboundShipmentEnabled) {
      shipmentsRoutes.push({
        key: "new_shipment_inbound",
        route: "NewShipment",
        index: "5",
        query: { type: "inbound" }
      });
    }

    if (
      this.$store.getters.features.storePaperlessEnabled &&
      !this.$store.getters["customer/config"].disablePaperlessFeature
    ) {
      shipmentsRoutes.push({
        key: "paperless_management",
        route: "PaperlessManagement",
        index: this.isInboundShipmentEnabled ? "6" : "5"
      });
    }

    if (
      this.$store.getters.features.storeCourierPickupsManagementEnabled &&
      this.$store.getters["customer/config"].pickupEnabled
    ) {
      shipmentsRoutes.push({
        key: "Courier Pickups Management",
        route: "CourierPickupsManagement",
        index: this.isInboundShipmentEnabled ? "7" : "6"
      });
    }

    if (
      this.$store.getters["customer/config"].enableWineShipmentCreation ||
      this.$store.getters["customer/config"].enableSpiritsShipmentCreation
    ) {
      shipmentsRoutes.push({
        key: "new_shipment_wine",
        route: "NewShipment",
        index: String(shipmentsRoutes.length + 1),
        query: { type: "wine" }
      });
    }

    return {
      shipment: shipmentsRoutes,
      pickups: [
        { key: "shipments", route: "ShipmentsManagement", index: "1" },
        { key: "mbe_centre_pickups", route: "PickupsList", index: "2" },
        {
          key: "new",
          route: "PickupDetails",
          index: "3",
          params: { id: "new" }
        }
      ],
      closures: [
        { key: "shipments", route: "ShipmentsManagement", index: "1" },
        { key: "historic_closures", route: "ClosuresList", index: "2" }
      ],
      "new-shipment": [
        { key: "Spedizioni", route: "ShipmentsMenuNew", index: "1" },
        { key: "new_shipment", route: "ShipmentsManagement", index: "2" },
        {
          key:
            this.$route.query.type === "inbound"
              ? "new_shipment_inbound"
              : "new_shipment_button",
          route: "NewShipment",
          index: "3",
          query: this.$route.query
        }
      ],
      "billing-management": [
        { key: "billing_management", route: "BillingManagement", index: "1" }
      ],
      apikey: [{ key: "apikey_setup", route: "ApiKeySetup", index: "1" }],
      loginHistory: [
        { key: "login_history_menu", route: "LoginHistory", index: "1" }
      ],
      deviceManagement: [
        {
          key: "device_management_menu",
          route: "DeviceManagement",
          index: "1"
        }
      ],
      claimManagement: [
        { key: "claim_management", route: "ClaimManagement", index: "1" }
      ],
      "pickup-details": [
        { key: "shipments", route: "ShipmentsManagement", index: "1" },
        { key: "mbe_centre_pickups", route: "PickupsList", index: "2" }
      ],
      contacts: [{ key: "contacts", route: "ContactsList", index: "1" }],
      "contact-details": [
        { key: "contacts", route: "ContactsList", index: "1" },
        { key: "detail", route: "ContactDetails", index: "2" }
      ],
      addresses: [{ key: "contacts", route: "AddressesList", index: "1" }],
      emailRegistration: [
        {
          key: "email_registration_setup",
          route: "EmailRegistration",
          index: "1"
        }
      ],
      setup: [
        { key: "ddp_third_part_code", route: "DDPThirdPartCode", index: "1" }
      ],
      defaultPackaging: [
        {
          key: "default_packaging_setup",
          route: "DefaultPackaging",
          index: "1"
        }
      ],
      shipment_cost_calculate: [
        { key: "Spedizioni", route: "ShipmentsMenuNew", index: "1" },
        {
          key: "shipment_cost_calculate",
          route: "ShipmentCostCalculate",
          index: "2"
        }
      ],
      records: [
        { key: "register", disabled: true, index: "1" },
        { key: "customers", disabled: true, index: "2" }
      ],
      tradeterms: [
        { key: "tradeterms_fuel", route: "TradetermsFuel", index: 1 }
      ]
    };
  }

  isActiveRoute(item) {
    return this.$route.name === item.route;
  }
}
